import { Component, OnInit } from '@angular/core';
import { SessionExpiryLabel_EN } from 'src/app/models/labels/sessionExpiryLabel_EN';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthorisationService } from 'src/app/services/authorisation/authorisation.service';
import { BorrowerRenderingService } from 'src/app/services/borrower/borrower-rendering.service';
import { QuoteRenderingService } from 'src/app/services/search/quote-rendering.service';
import { FooterLabel_EN } from 'src/app/models/labels/footerLabel_EN';
import { MainHeaderlabel_EN } from 'src/app/models/labels/mainHeaderLabel_EN';
import { BorrowerDTO } from 'src/app/models/borrower/borrower-dto';
import { IncomeDTO } from 'src/app/models/borrower/income-dto';
import { LoanStep1 } from 'src/app/models/borrower/loan-step1';
import { LoanStep2 } from 'src/app/models/borrower/loan-step2';
import { LoanStep3 } from 'src/app/models/borrower/loan-step3';
import { LoanStep4 } from 'src/app/models/borrower/loan-step4';
import { Parameter } from 'src/app/models/borrower/loanFormParameter';
import { NewQuote } from 'src/app/models/search/new-quote';
import { QuotationEntityIdDto } from 'src/app/models/search/quotation-entity-id-dto';
import { SearchQuote } from 'src/app/models/search/search-quote';


@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorMainComponent implements OnInit {
  footerLabel: FooterLabel_EN;
  headerLabel: MainHeaderlabel_EN;

  constructor(private router: Router, private route: ActivatedRoute, private authService: AuthorisationService,
    private borrowerService: BorrowerRenderingService, private quoteService: QuoteRenderingService) { }
  id;
  message: any;

  ngOnInit() {
    this.footerLabel = new FooterLabel_EN();
    this.headerLabel = new MainHeaderlabel_EN();
    this.message = new SessionExpiryLabel_EN();
    this.route.params.subscribe((params) => {
      // console.log(params);
      this.id = params['id'];
    });
  }

  logout() {
    this.authService.logout();
  }

  homePage() {

    this.borrowerService.primaryBorrower = new BorrowerDTO();
    this.borrowerService.incomeBorrower = new IncomeDTO();
    this.borrowerService.incomeCoBorrower = new IncomeDTO();
    this.borrowerService.loanStep1 = new LoanStep1();
    this.borrowerService.loanStep2 = new LoanStep2();
    this.borrowerService.loanStep3 = new LoanStep3();
    this.borrowerService.loanStep4 = new LoanStep4();
    this.borrowerService.parameter = new Parameter();
    this.borrowerService.coApplicantBorrower = new BorrowerDTO();

    this.quoteService.newQuote = new NewQuote();
    this.quoteService.quotation = new QuotationEntityIdDto();
    this.quoteService.searchQuote = new SearchQuote();
    this.quoteService.checkModifyButton = false;


    this.router.navigate(['/home']);
  }


}


